import ButtonContainer from "@components/ButtonContainer";
import FormTextField from "@components/Shared/FormTextField";
import renderSelectField from "@easydev/form/Select";
import { IUserDetail } from "@interfaces/Core/Users/userDetail";
import IFormProps from "@interfaces/Shared/formProps";
import useStates from "@mappers/Shared/getState.mapper";
import { ReactElement, useState } from "react";
import { Field } from "react-final-form";

interface IModifyForm extends IFormProps {
  data: IUserDetail;
}

const ModifyUserForm = ({
  handleSubmit,
  form,
  data,
}: IModifyForm): ReactElement => {
  const { GetState, GetStates } = useStates();
  const [status] = useState(GetState(data?.state));

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">{"Name"}</span>
        <div className="form__form-group-field">
          <Field
            name="name"
            component={FormTextField}
            type="text"
            placeholder="John"
            initialValue={data?.name}
            isAboveError
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">{"Last name"}</span>
        <div className="form__form-group-field">
          <Field
            name="lastname"
            component={FormTextField}
            type="text"
            placeholder="Doe"
            initialValue={data?.lastname}
            isAboveError
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">{"Username"}</span>
        <div className="form__form-group-field">
          <Field
            name="username"
            component={FormTextField}
            type="text"
            placeholder="jdoe"
            initialValue={data?.username}
            isAboveError
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">{"Mail"}</span>
        <div className="form__form-group-field">
          <Field
            name="mail"
            component={FormTextField}
            type="email"
            placeholder="john.doe@nftstudios.io"
            initialValue={data?.mail}
            isAboveError
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">{"State"}</span>
        <div className="form__form-group-field">
          <Field
            name="state"
            component={renderSelectField}
            type="text"
            placeholder={"Select a State"}
            options={GetStates()}
            initialValue={status}
            isAboveError
          />
        </div>
      </div>

      <ButtonContainer />
    </form>
  );
};

export default ModifyUserForm;
